import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { CompanyContextService } from '../../../services/company-context.service';
import { CustomerMigrationComponent } from '../../../onboarding/customer-migration/customer-migration.component';

/**
 * Customer migration for the company open in the detail shell.
 *
 * The route path stays `bulk-import` so existing links and bookmarks keep
 * working; what it renders is the migration tab, which treats vendor bridges as
 * temporary systems with a lifecycle rather than as import sources.
 */
@Component({
  selector: 'app-company-bulk-import',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule, CustomerMigrationComponent],
  template: `
    <app-customer-migration
      *ngIf="context.current$ | async as company"
      [companyId]="company.id"
      [companyName]="company.name || ''"
    ></app-customer-migration>
  `,
})
export class CompanyBulkImportComponent {
  readonly context = inject(CompanyContextService);
}
